import React, { useState, useEffect } from 'react';
import Cookies from "cookies-js"

import Box from '../Box'
import Timer from '../../common/Timer';
import { styled } from '../../../stitches.config';

export default function ABridTimerThree(props) {
    const [voted, setVoted] = useState(null)
    const [percentage, setPercentage] = useState(null)
    const [hasCookie, setHasCookie] = useState(false)

    if (typeof ABridTimerThree.counter == 'undefined') {
        ABridTimerThree.counter = 0;
    }

    useEffect(() => {
        const value = Cookies.get("_brid");
        if (typeof value === "string") {
            const [blockID, articleID] = value.split(".");
            setHasCookie(true)
            // console.log({ blockID, uid: props.settings.uID, props })
            if (blockID === props.settings.uID) {
                setVoted(articleID)
            }
        }
    }, [])

    return (
        <Section className="container">
            <div className="row">
                <Column className="col-xs-12 col-md-3">
                    <Box {...props}
                        id="b4"
                        type="ABridSideInfo"
                        settings={props.settings.b4}
                        classes=""
                        disableVote={false} />
                </Column>
                <Column className="col-xs-12 col-md-3">
                    <Box {...props}
                        id="b1"
                        type="ABridTileSmall2"
                        settings={props.settings.b1}
                        classes=""
                        secondArticleID={props.settings.b2?.articleID}
                        thirdArticleID={props.settings.b3?.articleID}
                        disableVote={false}
                        voted={voted}
                        setVoted={setVoted}
                        percentage={percentage}
                        setPercentage={setPercentage}
                        uID={props.settings.uID}
                        hasCookie={hasCookie}
                        votingResult={props.settings.votingResult}
                    />
                </Column>
                <Column className="col-xs-12 col-md-3">
                    <Box {...props}
                        id="b2"
                        type="ABridTileSmall2"
                        settings={props.settings.b2}
                        classes=""
                        secondArticleID={props.settings.b1?.articleID}
                        thirdArticleID={props.settings.b3?.articleID}
                        disableVote={false}
                        voted={voted}
                        setVoted={setVoted}
                        percentage={percentage}
                        setPercentage={setPercentage}
                        uID={props.settings.uID}
                        hasCookie={hasCookie}
                        votingResult={props.settings.votingResult}
                    />
                </Column>
                <Column className="col-xs-12 col-md-3">
                    <Box {...props}
                        id="b3"
                        type="ABridTileSmall2"
                        settings={props.settings.b3}
                        classes=""
                        secondArticleID={props.settings.b1?.articleID}
                        thirdArticleID={props.settings.b2?.articleID}
                        disableVote={false}
                        voted={voted}
                        setVoted={setVoted}
                        percentage={percentage}
                        setPercentage={setPercentage}
                        uID={props.settings.uID}
                        hasCookie={hasCookie}
                        votingResult={props.settings.votingResult}
                    />
                </Column>
            </div>
        </Section>
    );
}

const Section = styled("section",{
    "@bp4":{
        margin: "40px auto"
    }
});
const Column = styled("div",{
    paddingLeft: "2px !important",
    paddingRight: "2px !important"
});